import React from 'react';

const Solutions = () => {
  const cardData = [
    {
      image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744239433/image-3_lss5jw.png',
      title: 'Planning & management',
      location: 'Walvis Bay, Namibia',
    },
  ];

  return (
    <div className="relative bg-white px-4 md:px-20">
      {/* Content */}
      <div className="relative z-10   md:pt-5 pt-2">
        {/* Heading */}
        <div className="mt-4 md:mt-2 md:mb-5">
          <h1 className="text-[12px] md:text-[38px] font-bold text-[#FDBD26] ">
            Voice of Farmers
          </h1>
          <h1 className="text-[12px] md:text-[34px] font-normal text-black">
            Stay informed with insights and innovation in Agriculture
          </h1>
        </div>

        {/* Records Section */}
        <div className="bg-[#2E453D] rounded-md w-full md:h-[630px] h-[250px] relative flex items-center justify-center p-2 md:p-0 mt-4">
          {/* Flex to center the card */}
          <div className="flex justify-center items-center w-full h-full">
            {cardData.map((card, index) => (
              <div
                key={index}
                className="relative w-[40%] h-[90%] md:w-[390px] md:h-[550px] rounded-md overflow-hidden bg-cover bg-center"
                style={{ backgroundImage: `url(${card.image})`, zIndex: 10 }} // Ensure the card is in front
              >
                {/* Play Icon */}
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743776596/image_1502_utmsek.png"
                  alt="Play"
                  className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[40px] h-[40px] md:w-[100px] md:h-[100px] z-20"
                />
                  <a href="/">
                  <img
                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744202632/image_1538_bievzn.png"
                    alt="Logo"
                    className="w-[20px] h-[20px] absolute md:bottom-40 bottom-16 md:-left-5 left-2 md:mb-2 mb-3 sm:w-[60px] sm:h-[60px] md:w-[80px] md:h-[50px] xl:w-[140px] xl:h-[80px] object-contain"
                  />
                </a>
                <div className="absolute bottom-0 left-0 w-full p-4">
                  <h3 className="text-[8px] md:text-[22px] font-bold text-white">{card.title}</h3>
                  <p className="text-[4px] md:text-[18px] font-normal text-white">
                    Farmnet has improved my productivity by linking me with service providers & resources
                  </p>
                  <div className="flex items-center justify-between mt-2">
                    <div className="flex items-center gap-2">
                      <img
                        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744235659/image_20_ujukab.png"
                        alt="Location"
                        className="md:w-5 md:h-5 w-3 h-3"
                      />
                      <p className="text-white text-[6px] flex md:text-[14px] font-medium">
                        <strong className="font-medium md:flex hidden">Walvis Bay, </strong>Namibia
                      </p>
                    </div>
                    <img
                      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744205132/Expand_right_unwap6.png"
                      alt="Person"
                      className="md:w-8 h-3 w-3 md:h-8"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="absolute left-4 md:left-6 top-0 md:top-4 w-[70px] md:w-[200px] h-[50px] md:h-[80px] z-10">
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744195055/image_14_o9yorx.png"
              alt="Logo"
              className="w-full h-full object-contain"
            />
          </div>
          <div className="absolute md:bottom-8 bottom-2 md:left-8 left-2 right-8 text-left">
                            <p className="text-white text-[12px] md:text-[40px] font-bold">Productivity</p>
                        </div>
        </div>
      </div>
      <div className='px-1'>
  {/* Content Section */}
  <div className="mt-5 max-w-screen-xl w-full">
    <h3 className="text-black font-normal text-[14px] md:text-[30px]">March 03, 2025</h3>
    <div className="flex items-center gap-6 md:gap-8 text-[13px] md:text-[30px] font-normal text-black">
      <p>Story by Editorial team</p>
      <div className="flex items-center gap-2 text-[#155528]">
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743893169/Time_progress_light_ecbt3q.png"
          alt="Clock"
          className="h-6 w-6 md:h-8 md:w-8"
        />
        <p>2 Minutes read</p>
      </div>
    </div>
  </div>

  {/* Main Text Section */}
  <div className="md:mt-5 mt-3 md:space-y-10 space-y-5">
    <p className="text-[8px] md:text-[32px] text-black font-medium">
    “ using Farmnet to access good service providers , i have been able to get the right support to improve my production “.
    </p>

    <p className="text-[8px] md:text-[32px] text-black font-normal "  style={{lineHeight:'1.30'}}>
      <strong  className=' font-bold'>Productivity Solution:</strong>  <br/> Farment connects farmers with verified service providers who offer timely, accurate advice and expert guidance. This enables farmers to make informed decisions and enhance their production, leading to improved efficiency and productivity..<br />

    </p>
    
<div className='md:h-10 h-2'></div>
  </div>
</div>

    </div>
  );
};

export default Solutions;
